// extracted by mini-css-extract-plugin
module.exports = {"chromeframe":"Landing_chromeframe__cuMej","main":"Landing_main__10ddC"};